// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
        <path fill="none" fill-rule="evenodd" stroke="#323F4D" stroke-linecap="round" stroke-width="1.5" d="M11 6H1"/>
    </svg>`
};

export const IconMapZoomMinusHtml = icon.__html;

export const IconMapZoomMinus = () => <span dangerouslySetInnerHTML={icon} />;

export default IconMapZoomMinus;
